module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerut0a-ch1301",
      "epub:type": "division",
      "id": "ut0a-ch13"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerut0a-ch1301"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20005#toc"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Joint Committee, Proposed Apportionment Amendment, Exclusion of “Insurgent States”")]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("January 9, 1866"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chilashvol20268#fn16",
      "id": "fn16r",
      "role": "doc-noteref"
    }
  }, [_vm._v("16*")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('i', [_vm._v("Mr. Stevens")]), _vm._v(" submitted a joint resolution, upon which he asked immediate action by the Committee, proposing to submit for ratification to the several States the following amendment to the Constitution of the United States:")]), _vm._v(" "), _c('p', [_vm._v("Representatives shall be apportioned among the several States, which may be included within this Union, according to the number of their respective legal voters; and for this purpose none shall be considered as legal voters who are not either natural born or naturalized "), _c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p33"
    }
  }), _vm._v("citizens of the United States, of the age of twenty-one years.")]), _vm._v(" "), _c('p', [_vm._v(". . .")]), _vm._v(" "), _c('p', [_vm._v("The further consideration of the subject was postponed till this evening.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("The Chairman")]), _vm._v(" submitted the following:")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("Resolved")]), _vm._v(", That, in the opinion of this Committee, the insurgent States cannot, with safety to the rights of all the people of the United States, be allowed to participate in the Government until the basis of representation shall have been modified, and the rights of all persons amply secured, either by new provisions, or the necessary changes of existing provisions, in the Constitution of the United States, or otherwise.")]), _vm._v(" "), _c('p', [_vm._v("On motion of "), _c('i', [_vm._v("Mr. Stevens")]), _vm._v(", the further consideration of the resolution was postponed for the present.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21da9baa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lash-vol2-0023.vue
// module id = 120
// module chunks = 0